import { z } from "zod";

export const replayResultSchema = z.object({
	result: z.boolean(),
});

export type ReplayResult = z.infer<typeof replayResultSchema>;
